import { findModuleExport } from '../webpack';
/** @component React Components */
export const Carousel = findModuleExport((e) => e.render?.toString().includes('setFocusedColumn:'));
